import React from 'react';

import { FormBlock } from '@/widgets/ServiceFormTemplate';

import { DocumentsData } from '@/features/ui/DocumentsData';

import { IntegrationSystem } from '@/shared/types';

import { DocumentTypeEntity } from '@/api/types';

import { MAX_SELECTED_INSURANCE_ORDERS } from '../lib/utils';

type ConfirmInsuranceViewProps = {
  insuranceDocumentMetadata?: Array<DocumentTypeEntity<IntegrationSystem.ERZ>>;
  currentRequestId?: Nullable<string>;
};

export const ConfirmInsuranceView: React.FC<ConfirmInsuranceViewProps> = ({
  insuranceDocumentMetadata = [],
  currentRequestId,
}) => {
  return (
    <FormBlock title="Дані документу про страхування">
      <DocumentsData
        withUploader
        documentsRequired
        documentTypeEntities={insuranceDocumentMetadata}
        name="confirmInsuranceDocuments"
        maxDocumentsCount={MAX_SELECTED_INSURANCE_ORDERS}
        request_id={currentRequestId ?? ''}
        documentUploadLabel="Копія поліса"
        documentTypeSelectHidden
      />
    </FormBlock>
  );
};
